
document.addEventListener('DOMContentLoaded' , () =>{	
	// Common - view
	if(document.querySelector('.common-view-page') || document.querySelector('.comm-write-page')){
		const openList = document.querySelectorAll('.write-open-info .write-open-info__ul>li');

		openList.forEach(el =>{
			const oepnBtn = el.querySelector('.open-btn');

			oepnBtn.addEventListener('click' , ()=>{				
				oepnBtn.classList.toggle('on');
			})
		})
	}
});
